import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, ChevronDown, ChevronUp, FileText } from 'lucide-react';
import { eur } from '../ExpenseDetail/DetailKpis';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const VISIBLE = 3;

export const ExpenseAlerts = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/gastos/alertas?dias=60`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
    }).then(r => (r.ok ? r.json() : null)).then(setData).catch(() => setData(null));
  }, []);

  if (!data?.alerts.length) return null;
  const list = expanded ? data.alerts : data.alerts.slice(0, VISIBLE);

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 space-y-2" data-testid="expense-alerts">
      <div className="flex items-start gap-2 text-sm">
        <TrendingUp size={17} className="text-amber-900 mt-0.5 shrink-0" />
        <p className="font-semibold text-amber-900">
          {data.alerts.length} gasto{data.alerts.length > 1 ? 's' : ''} más alto{data.alerts.length > 1 ? 's' : ''} de lo normal
          <span className="block sm:inline sm:ml-1 font-normal text-xs sm:text-sm text-amber-700">+{data.threshold_pct}% sobre la media del proveedor · últimos {data.dias} días</span>
        </p>
      </div>
      {list.map(a => (
        <div key={a.id} className="flex items-center gap-3 bg-white rounded-lg px-3 py-2 text-sm" data-testid={`expense-alert-${a.id}`}>
          <button className="flex-1 min-w-0 text-left" onClick={() => navigate(`/admin/gastos/categoria/${a.category}?proveedor=${encodeURIComponent(a.vendor)}`)}
            data-testid={`expense-alert-open-${a.id}`}>
            <span className="font-medium text-gray-900">{a.vendor}</span>
            <span className="text-gray-400"> · {a.date?.split('-').reverse().join('/')}</span>
            <span className="block text-xs text-gray-500">Normalmente {eur(a.average)} → esta vez {eur(a.amount)}</span>
          </button>
          <span className="font-bold text-red-600 shrink-0" data-testid={`expense-alert-pct-${a.id}`}>+{a.pct}%</span>
          {a.invoice_url && (
            <a href={a.invoice_url.startsWith('http') ? a.invoice_url : `${API_URL}${a.invoice_url}`} target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800" data-testid={`expense-alert-invoice-${a.id}`}><FileText size={16} /></a>
          )}
        </div>
      ))}
      {data.alerts.length > VISIBLE && (
        <button onClick={() => setExpanded(e => !e)} className="text-xs font-medium text-amber-800 flex items-center gap-1" data-testid="expense-alerts-toggle">
          {expanded ? <>Ver menos <ChevronUp size={14} /></> : <>Ver los {data.alerts.length} <ChevronDown size={14} /></>}
        </button>
      )}
    </div>
  );
};
